import { useHandleInputChange } from '../../hook/useHandleInputChange';
import { useOnSavePostClicked } from './hook/useOnSavePostClicked';
import { useInvalidLangs } from '../../hook/useInvalidLangs';
import { HelmetProvider } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { initialState } from './initialStates/create';
import { useState } from 'react';
import ToastNotfication from '../../components/toastNotfication';
import InputMultyLang from '../../components/common/Input/inputMultyLang';
import Button from '../../components/common/Button/button';
import 'react-toastify/dist/ReactToastify.css';
const Index = () => {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState('az');
    const languages = ['az', 'en', 'ru'];
    const { formState, handleInputChange } = useHandleInputChange(initialState);
    const { response, loading, formError, onSavePostClicked } = useOnSavePostClicked(formState);
    const { invalidLangs } = useInvalidLangs(formError, loading, response);
    return (
        <HelmetProvider>
            <div className="page-wrapper">
                <div className="page-content">
                    <div className="row">
                        <div className="col-xl-9 mx-auto">
                            <div className="card">
                                <div className="card-body">
                                    <div className="mb-4">
                                        <ul className="nav nav-tabs">
                                            {languages.map(lang => (
                                                <li className="nav-item" key={lang}>
                                                    <button
                                                        className={`nav-link ${invalidLangs?.includes(lang) ? 'invalid-bg' : ''}   ${activeTab === lang ? 'active' : ''}`}
                                                        onClick={() => setActiveTab(lang)}
                                                    >
                                                        {lang.toUpperCase()}
                                                    </button>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div className="p-4 border rounded">
                                        <form className="row g-3" >

                                            <InputMultyLang
                                                label={`${t('properties.name')} (${activeTab})`}
                                                id={`name-${activeTab}`}
                                                name="name"
                                                value={formState.name?.[activeTab] || ''}
                                                error={formError?.[`name.${activeTab}`]}
                                                onChange={(e) => handleInputChange(e, activeTab)}
                                            />
                                            <Button
                                                label={t('properties.save')}
                                                onClick={onSavePostClicked}
                                                isLoading={loading}
                                                disabled={loading}
                                            />
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastNotfication response={response} />
        </HelmetProvider>
    );
};

export default Index;